module.exports = __webpack_public_path__ + "media/icons/xing-f9556469.svg";